import {
  dealTypeFromJsonQuery,
  FDealType,
  FOfferType,
  offerTypeFromJsonQuery,
  type TJsonQuery,
} from '../../../packages/JsonQuery';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export function getIsRoomSale(jsonQuery: TJsonQuery) {
  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  // Только продажа комнат
  const isRoomSale = offerType === FOfferType.Room && dealType === FDealType.Sale;

  return isRoomSale;
}
